import { ChartTooltip } from './chart-tooltip/chart-tooltip';
import React from 'react';
import { CaptionText, FlexColumn, FlexRow } from '@make-software/cspr-design';
import { BodyText, formatDateWithWeekday } from '@block-explorer/ui';

interface CustomTooltipProps {
  active?: boolean;
  payload?: Array<{ value; name }>;
  label?: string;
  format: (value: any) => string;
}

export const GraphTooltip = ({
  active,
  payload,
  label,
  format,
}: CustomTooltipProps) => {
  const convertGraphKeyToItemLabel = (key) =>
    key.includes('_') ? key.replace(/_/g, ' ') : key;

  if (!active || !payload?.length) {
    return null;
  }

  return (
    <ChartTooltip>
      <CaptionText size={2} variation="darkGray">
        {label && formatDateWithWeekday(label)}
      </CaptionText>
      <br />
      <FlexColumn itemsSpacing={4}>
        {payload?.map((item) => (
          <FlexRow
            key={item.name}
            align="baseline"
            justify="space-between"
            itemsSpacing={10}
          >
            {payload?.length > 1 && (
              <BodyText size={3} capitalizeFirstLetter>
                {convertGraphKeyToItemLabel(item.name)}:
              </BodyText>
            )}
            <BodyText size={1} scale={'lg'} lineHeight={'sm'}>
              {format(item.value)}
            </BodyText>
          </FlexRow>
        ))}
      </FlexColumn>
    </ChartTooltip>
  );
};
